<template>
  <div class="form-layout--wrapper" :class="{ large }">
    <!-- h2, когда заголовок есть: на витринах это единственный видимый заголовок
         страницы, и до RBXGD-1100 он был обычным div — в DOM money-страницы не
         было ни одного заголовка, кроме h1, уведённого за экран классом
         .seo-title. Тег меняется без визуальных последствий: reset обнуляет
         margin, padding и font-size одинаково для div и h2, а размер задаёт
         класс .landing-title. Пустой заголовок остаётся div: элемент нужен, он
         участвует в отступах формы, но пустой h2 — мусор в структуре. -->
    <component
      :is="titleWithMobile ? 'h2' : 'div'"
      class="form-layout__main-title landing-title"
      :class="{ sm: smallTitle }"
      v-html="titleWithMobile"
    />

    <div class="form-layout" :class="{ 'flat-footer': flatFooter, large }">
      <div class="form-layout__header" :class="{ show: showHeader }">
        <div v-if="showBack && !hideClose" class="form-layout__back" @click="$emit('back')">
          <Icon name="/slider/arrow.svg" />
        </div>
        <div class="form-layout__close" @click="closeForm">
          <Icon name="/base/close.svg" />
        </div>
      </div>
      <div class="form-layout__body" :class="{ 'close-hide': hideClose }">
        <slot name="header" />
        <div v-if="title || subTitle || $slots['sub-title']" class="form-layout__title-wrap" :class="[titleClass]">
          <component :is="titleTag" class="form-layout__title" v-html="title" />
          <div v-if="subTitle" class="form-layout__sub-title" :class="{ sm: smallTitle }" v-html="subTitle" />
          <slot name="sub-title" />
        </div>
        <slot />
      </div>
    </div>

    <div v-if="!hideFooter" class="form-layout__footer">
      <Button
        v-if="showBack"
        class="form-layout__button form-layout__button--back"
        left-icon="/base/arrow-left.svg"
        @click="$emit('back')"
      >
        {{ $t('actions.back') }}
      </Button>
      <Button
        class="form-layout__button form-layout__button--submit"
        :right-icon="submitText ? null : '/base/arrow-right.svg'"
        :disabled="disabled"
        @click="$emit('submit')"
      >
        {{ submitText || $t('actions.continue') }}
      </Button>
    </div>
  </div>
</template>
<script>
import Icon from '@/components/Base/Icon/Icon.vue'
import Button from '@/components/Base/Button/Button.vue'
import windowSize from '@/mixins/windowSize'
import ScreenSize from '@/enums/ScreenSize'

export default {
  name: 'FormLayout',
  mixins: [windowSize],
  props: {
    mainTitle: {
      value: String,
      default: ''
    },
    title: {
      value: String,
      default: ''
    },
    mobileTitle: {
      value: String,
      default: ''
    },
    subTitle: {
      value: String,
      default: ''
    },
    showBack: {
      value: Boolean,
      default: true
    },
    hideClose: {
      value: Boolean,
      default: false
    },
    close: {
      value: Function,
      default: null
    },
    back: {
      value: Function
    },
    flatFooter: {
      value: Boolean,
      default: false
    },
    smallTitle: {
      value: Boolean,
      default: false
    },
    large: {
      value: Boolean,
      default: false
    },
    titleClass: {
      value: String,
      default: ''
    },
    submitText: {
      value: String
    },
    hideFooter: {
      value: Boolean,
      default: false
    },
    disabled: {
      value: Boolean,
      default: false
    },
    showHeader: {
      value: Boolean,
      default: false
    },
    titleType: {
      value: String
    }
  },
  components: { Button, Icon },
  data() {
    return {
      windowHeight: window.innerHeight
    }
  },
  mounted() {
    window.addEventListener('resize', this.updateWindowHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWindowHeight)
  },
  methods: {
    closeForm() {
      this.close ? this.close() : this.$router.push('/')
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight
    }
  },
  computed: {
    titleTag() {
      return this.titleType ? this.titleType : 'div'
    },
    titleWithMobile() {
      const mobileTitle = this.mobileTitle || this.mainTitle
      return this.screenWidth < ScreenSize.MOBILE_LG ? mobileTitle : this.mainTitle
    }
    /* Фича не прижилась в UX
    maxHeight () {
      return {
        maxHeight: this.windowHeight - (this.windowHeight * 0.2) + 'px'
      }
    } */
  }
}
</script>

<style lang="scss" scoped>
@import './form-layout';
</style>
